import { useContext } from 'react';
import AuthenticationContext, { AuthenticationContextValue } from './AuthenticationContext';

export default function useAuthentication(): AuthenticationContextValue {
    return useContext(AuthenticationContext);
}
